import React from 'react';
import {Button} from 'components';
import {includes, useNamedSelector} from 'helpers';
import css from './repetition.module.scss';

export function WeekDays({ value, toggleDay }) {
  return (
    <div className={css.weekdays}>
      { useNamedSelector('calendar.week').map(day =>
        <Button
          key={day}
          pressed={includes(value, day.isoWeekday())}
          onClick={() => toggleDay(day)}
          children={day.format('dd')}
          icon="check"
          className="checkbox"
        />
      ) }
    </div>
  );
}
